<confirmation-dialog-svg-sprite />
<close-dialog-cross-icon-svg />

<div class="confirmation-dialog-main-div">

  <div class="confirmation-dialog-header-div">

    <div class="confirmation-dialog-header-title-div">

      @if (isTitleTrashIconEnabled) {
        <svg class="confirmation-dialog-header-title-icon">
          <use xlink:href="#trashHeaderTitleIcon"></use>
        </svg>
      }

      <div class="confirmation-dialog-header-title-text">
        {{title}}
      </div>

    </div>

    <svg class="confirmation-dialog-header-close-btn-icon" (click)="cancel()">
      <use xlink:href="#closeDialogCrossIcon"></use>
    </svg>

  </div>

  <div class="confirmation-dialog-body-div">

      @if (isConfirmationTrashIconEnabled) {
        <svg class="confirmation-dialog-body-info-icon">
          <use xlink:href="#trashConfirmIcon"></use>
        </svg>
      }

    <div class="confirmation-dialog-body-info-text">
      {{confirmationText}}
    </div>

  </div>

  <div class="confirmation-dialog-footer-div">

    <button class="confirmation-dialog-footer-button confirmation-dialog-close-button" (click)="cancel()">
      @if(leftButtonText) {
        {{leftButtonText}}
      } @else {
        {{ "common.no" | translate }}
      }
    </button>

    <button class="confirmation-dialog-footer-button confirmation-dialog-confirm-button" (click)="confirm()">
      @if(rightButtonText) {
        {{rightButtonText}}
      } @else {
        {{ "common.yes" | translate }}
      }
    </button>

  </div>

</div>


